import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useI18n, tx } from './i18n';
import { asArray } from './shared';

const API = process.env.REACT_APP_API_URL || '';

// ── Baner ogloszen systemowych ───────────────────────────────────────────────
// Wydzielone z Admin.js, bo baner widza WSZYSCY uzytkownicy, a panel admina
// tylko administratorzy. Trzymanie ich w jednym pliku wymuszaloby ladowanie
// calego (ciezkiego) kodu panelu admina u kazdego usera -- co niweczylo zysk
// z leniwego ladowania.

export const ANN_LEVELS = {
  info:     { bg:'rgba(0,184,255,0.1)',  border:'rgba(0,184,255,0.4)',  color:'#00b8ff', icon:'ℹ️' },
  warning:  { bg:'rgba(255,187,0,0.1)',  border:'rgba(255,187,0,0.45)', color:'#ffbb00', icon:'⚠️' },
  critical: { bg:'rgba(224,92,92,0.12)', border:'rgba(224,92,92,0.5)',  color:'#e05c5c', icon:'🚨' },
};

export function AnnouncementsBanner() {
  const { t } = useI18n();
  const [items, setItems] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('dismissed_announcements') || '[]'); }
    catch { return []; }
  });

  useEffect(() => {
    axios.get(`${API}/api/announcements`)
      .then(r => setItems(asArray(r.data)))
      .catch(() => {});  // ciche niepowodzenie -- baner to dodatek, nie może psuc aplikacji
  }, []);

  const dismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    try { localStorage.setItem('dismissed_announcements', JSON.stringify(next.slice(-50))); } catch {}
  };

  const visible = items.filter(a => a.level === 'critical' || !dismissed.includes(a.id));
  if (visible.length === 0) return null;

  return (
    <div style={{ padding: '0 24px', marginBottom: 16 }}>
      {visible.map(a => {
        const s = ANN_LEVELS[a.level] || ANN_LEVELS.info;
        return (
          <div key={a.id} style={{
            background: s.bg, border: `1px solid ${s.border}`, borderRadius: 8,
            padding: '12px 16px', marginBottom: 8, display: 'flex', gap: 12, alignItems: 'flex-start',
          }}>
            <span style={{ fontSize: 16, lineHeight: 1.4 }}>{s.icon}</span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ color: s.color, fontWeight: 700, fontSize: 14, marginBottom: 2 }}>{a.title}</div>
              <div style={{ color: 'var(--text)', fontSize: 13, lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{a.body}</div>
              <div style={{ fontSize: 10, color: 'var(--text-dim)', marginTop: 4 }}>
                {a.author_callsign && `— ${a.author_callsign}`}
                {a.expires_at && (' ' + tx('· do {0}', [new Date(a.expires_at).toLocaleDateString('pl-PL')]))}
              </div>
            </div>
            {a.level !== 'critical' && (
              <button type="button" onClick={() => dismiss(a.id)} title={t('admin.dismissAnnouncement')}
                style={{ background:'none', border:'none', color:'var(--text-dim)', cursor:'pointer',
                  fontSize:16, lineHeight:1, padding:2 }}>×</button>
            )}
          </div>
        );
      })}
    </div>
  );
}
